import office from '@/taskpane/officejs/office-wrapper'
import CallbackArgs, { defaultCallbackArgs } from '../messages/callback-args'
import MessageArgs from '../messages/message-args'
import sendMessageToSidebar from '../messages/send-message-to-sidebar'
import PersonInfo from '../models/person-info'

interface AddRecipientsArgs extends MessageArgs {
  targetList: string
  emails: PersonInfo[]
}

export default async function addRecipientsHandler(data: AddRecipientsArgs) {
  let addRecipientsAsync: (emails: Office.EmailAddressDetails[]) => Promise<boolean>
  switch (data.targetList) {
    case 'to':
      addRecipientsAsync = office.mail.addTo
      break
    case 'cc':
      addRecipientsAsync = office.mail.addCc
      break
    case 'bcc':
      addRecipientsAsync = office.mail.addBcc
      break
  }

  const args: CallbackArgs = defaultCallbackArgs()

  try {
    await addRecipientsAsync(data.emails as Office.EmailAddressDetails[])
  } catch (error) {
    args.errorMessage = error || 'Failed to add recipients'
  } finally {
    sendMessageToSidebar('AddRecipientsCallback', args)
  }
}
